import { Action, createReducer, on } from '@ngrx/store';
import { weekPickerActions } from './week-picker.actions';
import { weekPickerInitialState, WeekPickerState } from './week-picker.state';

const reducer = createReducer(
  weekPickerInitialState,

  on(weekPickerActions.selectWeek, (state, { week }) => ({
    ...state,
    selectedWeek: week,
  })),

  on(weekPickerActions.setViewMonth, (state, { month, year }) => ({
    ...state,
    viewMonth: month,
    viewYear: year,
  })),

  on(weekPickerActions.navigateToToday, (state) => ({
    ...state,
    viewMonth: new Date().getMonth(),
    viewYear: new Date().getFullYear(),
    selectedWeek: state.selectedWeek,
  })),
);

export function weekPickerReducer(state: WeekPickerState | undefined, action: Action) {
  return reducer(state, action);
}
